import { AxiosResponse } from 'axios';
import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError } from '../../helper/Alert';
import { IBpmGetNew } from '../../interfaces/Bpm';
import { fetchBpmNewCaseUrlSuccess } from '../actions';

const getNewCase = async (params: IBpmGetNew) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(
    `bpmInstance/NewCase?engineCode=${encodeURIComponent(
      params.engineCode,
    )}&wfclassId=${encodeURIComponent(params.workflowClassId)}`,
  );
};

// Contacts
function* fetchBpmNewCaseRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    if (
      action.payload.engineCode === null ||
      action.payload.workflowClassId === null
    ) {
      return;
    }
    const fetchedBpmNewCase = yield call(getNewCase, action.payload);
    yield put(fetchBpmNewCaseUrlSuccess(fetchedBpmNewCase.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchBpmNewCase() {
  yield takeEvery(ActionTypes.GET_BPM_NEW_CASE_URL, fetchBpmNewCaseRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchBpmNewCase)]);
}
